import React from 'react'
import './css/news-letter.css'

const NewsLetter = () => {
    return (
        <div className='news-letter'>
            <h1>Get Exclusive Offers On your Email</h1>
            <p>Subscribe to our newsletter and stay updated</p>
            <div className="news-letter-input">
                <input type="text" placeholder='Enter your email' />
                <button>Subscribe</button>
            </div>
        </div>
    )
}

export default NewsLetter